import React from 'react';

const IntegrationBrandingPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default IntegrationBrandingPage;
